import { StyledSkeleton } from "./Skeleton.style.js";
import { DefaultSkeletonProps, SkeletonProps } from "./Skeleton.types.js";

const defaultProps: DefaultSkeletonProps = {
    width: "100%",
    height: "auto",
};

export const Skeleton = (props: SkeletonProps): JSX.Element => {
    const { children, ...attributes } = { ...defaultProps, ...props };

    return <StyledSkeleton {...attributes}>{children}</StyledSkeleton>;
};
